export enum CampaignStatus {
  PENDING_APPROVAL = 'pending_approval',
  AWAITING_REVIEW = 'awaiting_review',
  APPROVED = 'approved',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  RUNNING = 'running',
  ENDED = 'ended',
  FINISHED = 'finished',
  CANCELED = 'canceled',
  STOPPED = 'stopped',
}

export enum Roles {
  artist = 'artist',
  curator = 'curator',
  influencer = 'influencer',
  agent = 'agent',
  label = 'label',
  manager = 'manager',
  publisher = 'publisher',
}

export enum ArtistRolesEnum {
  ARTIST = 'artist',
  AGENT = 'agent',
  LABEL = 'label',
  MANAGER = 'manager',
  PUBLISHER = 'publisher',
}

export enum VideoStatus {
  ACCEPTED = 'accepted',
  CANCELED_BY_ARTIST = 'canceled_by_artist',
  APPROVED_BY_ARTIST = 'approved_by_artist',
  APPROVED_AUTOMATICALLY = 'approved_automatically',
  APPROVED_BY_ADMIN = 'approved_by_admin',
  CANCELED = 'canceled',
  AWAITING_REVIEW = 'awaiting_review',
  DECLINED = 'declined',
  AWAITING_MODERATOR_REVIEW = 'awaiting_moderator_review',
  REJECTED = 'video_rejected',
  DISMISSED = 'video_dismissed',
}

export enum PremoderationStatus {
  NEW_VIDEO = 'newVideo',
  MONITORING = 'monitoring',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected',
}

export enum PaymentMethodEnum {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  Credits = 'credits',
  PAYPAL_BILLING_AGREEMENT = 'paypalBillingAgreement',
  APPLE_PAY = 'applePay',
  GOOGLE_PAY = 'googlePay',
}

export type WalletPaymentMethod =
  | PaymentMethodEnum.APPLE_PAY
  | PaymentMethodEnum.GOOGLE_PAY

export enum PaymentStatusEnum {
  PAYED = 'payed',
  COMPLETED = 'completed',
  CHARGED_BACK = 'charged-back',
  COUPON_BONUS = 'bonus_credit_coupon',
}

export enum TagManagerEnum {
  WIDER_LANGUAGES_MATCHING = 'Match selected and other languages (wider selection)',
  SELECTED_LANGUAGES_ONLY = 'Match selected language only',
}

export enum ReviewerBalanceHistory {
  PAYMENT = 'payment',
  PAYOUT = 'payout',
  WITHDRAW = 'withdraw',
  CANCELED = 'canceled',
  REWARD_WITH_PLACEMENT = 'reward_with_placement',
  REWARD_WITHOUT_PLACEMENT = 'reward_without_placement',
  REVIEW_BONUS_PLACEMENT = 'review_bonus_placement',
  REVIEW_BONUS_LIKE = 'review_bonus_like',
}

export enum DeauthorizedReasonEnum {
  AGE_CHANGED = 'age_changed',
  BANNED = 'banned',
  DELETED = 'deleted',
  DISCONNECTED = 'disconnected',
  REVOKED = 'revoked',
  TOKEN_EXPIRED = 'token_expired',
  UNEXPECTED = 'unexpected',
  UNKNOWN = 'unknown',
}
